import React from 'react';
import { Card, CardBody, CardHeader, Button } from '@heroui/react';
import { ClipboardDocumentIcon, DocumentArrowUpIcon } from '@heroicons/react/24/outline';
import { useAppContext } from '../contexts/AppContext';
import { useCopyFunctionality } from '../hooks/useCopyFunctionality';

const SuggestionsSection = () => {
  const { state } = useAppContext();
  const { suggestions, editorWidth } = state;
  const { copyStatus, handleCopySuggestions, handleCopyToEditor } = useCopyFunctionality();

  return (
    <div 
      className="h-full overflow-y-auto bg-white dark:bg-gray-800 border-l border-gray-200 dark:border-gray-700"
      style={{ width: `${100 - editorWidth}%` }}
    >
      <Card className="h-full rounded-none shadow-none border-0">
        <CardHeader className="flex gap-3 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 border-b border-gray-200 dark:border-gray-700">
          <div className="flex flex-col flex-1">
            <p className="text-lg font-semibold text-gray-800 dark:text-gray-200">AI Suggestions</p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Powered by AI to help improve your report
            </p>
          </div>
        </CardHeader>
        
        <CardBody className="p-4 space-y-4">
          {suggestions ? (
            <>
              <div className="flex gap-2 mb-3">
                <Button
                  size="sm"
                  color="primary"
                  variant="flat"
                  startContent={<ClipboardDocumentIcon className="h-4 w-4" />}
                  onPress={() => handleCopySuggestions(suggestions)}
                  className="flex-1"
                >
                  Copy Suggestions
                </Button>
                <Button
                  size="sm"
                  color="success"
                  variant="flat"
                  startContent={<DocumentArrowUpIcon className="h-4 w-4" />}
                  onPress={() => handleCopyToEditor(suggestions)}
                  className="flex-1"
                >
                  Copy to Editor
                </Button>
              </div>
              
              {copyStatus && (
                <div className="text-sm text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20 p-2 rounded-md">
                  {copyStatus}
                </div>
              )}
              
              <div className="prose prose-sm max-w-none dark:prose-invert">
                {suggestions.includes('<!DOCTYPE html>') ? (
                  <div 
                     dangerouslySetInnerHTML={{ __html: suggestions }}
                     className="ai-review-content"
                  />
                ) : (
                  <div className="whitespace-pre-wrap text-gray-700 dark:text-gray-300 leading-relaxed">
                    {suggestions}
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-blue-100 to-purple-100 dark:from-blue-900/30 dark:to-purple-900/30 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <p className="text-gray-500 dark:text-gray-400 text-sm">
                Write some text and click "AI Suggestions" to get started
              </p>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default SuggestionsSection; 